import KeyboardShortcut from './KeyboardShortcut';

export default KeyboardShortcut;
